import React from "react";
import CohortDetailsPreview from "../components/cohorts/CohortDetailsPreview";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

function PreviewCohort() {
  const qalortUser = useSelector((state) => state.user.userData);
  const { slug } = useParams();
  const navigate = useNavigate();

  const handleClose = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(qalortUser?.user_type === "instructor" ? "/dashboard" : "/");
    }
  };
  return (
    <div>
      <CohortDetailsPreview slug={slug} isOpen={true} onClose={handleClose} />
    </div>
  );
}

export default PreviewCohort;
